(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('MacroDeleteController',MacroDeleteController);

    MacroDeleteController.$inject = ['$uibModalInstance', 'entity', 'Macro'];

    function MacroDeleteController($uibModalInstance, entity, Macro) {
        var vm = this;
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.macro = entity;
            });
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            Macro.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
